{
  "instances": {
    "quartz": {
      "actions": "Aðgerðir",
      "active_triggers": "Virkir Kveikir",
      "associated_triggers": "Tengdir Kveikir",
      "associated_with_calendar": "Tengt dagatalinu",
      "basic_information": "Grunnupplýsingar",
      "calendar": "Dagatal",
      "class": "Flokkur",
      "configuration": "Stilling",
      "cron_expression": "Cron-Orðatiltæki",
      "custom_trigger": "Sérsniðinn Kveikir",
      "days_of_week": "Dagar Vikunnar",
      "description": "Lýsing",
      "details": "Smáatriði",
      "disabled": "Óvirkt",
      "durable": "Stöðugur",
      "enabled": "Virkt",
      "end_time": "Lokatími",
      "final_fire_time": "Lokatími Kveikju",
      "friday": "Föstudagur",
      "group": "Hópur",
      "infinite": "Óendanlegur",
      "interval": "Millibil",
      "job_data": "Gögn Verks",
      "job_name": "Heiti Verks",
      "jobs": "Verk",
      "key": "Lykill",
      "label": "Quartz",
      "last_fire": "Síðasta Kveikiun",
      "last_fire_time": "Tími Síðustu Kveikju",
      "monday": "Mánudagur",
      "name": "Heiti",
      "next_fire": "Næsta Kveikiun",
      "next_fire_time": "Næsta Kveikiun",
      "no": "Nei",
      "no_data": "Engar upplýsingar um Quartz",
      "paused_triggers": "Stöðvuðir Kveikir",
      "preserve_hour_of_day": "Varðveita Tíma Dags",
      "priority": "Forgangur",
      "recovery": "Endurheimtur",
      "repeat_count": "Endurtaka Fjöldi",
      "request_recovery": "Óska eftir Endurheimtun",
      "saturday": "Laugardagur",
      "schedule_configuration": "Dagskrársetting",
      "skip_day_if_hour_does_not_exist": "Sleppa Degi ef Tími Ekki Til",
      "start_time": "Upphafstími",
      "state": "Staða",
      "sunday": "Sunnudagur",
      "system_default": "Sjálfgefið Kerfi",
      "thursday": "Fimmtudagur",
      "time_window": "Tímagluggi",
      "time_zone": "Tímabelti",
      "times_triggered": "Fjöldi Kveikinga",
      "timing_information": "Tíðarupplýsingar",
      "total": "samtals",
      "trigger_data": "Gögn Kveikis",
      "trigger_failed": "Hnötunargildi mistókst",
      "trigger_failed_message": "Villa við að framkalla starf: {error}",
      "trigger_failed_notification": "Villa við að framkalla starf \"{jobName}\": {error}",
      "trigger_fire_times": "Tímar Kveikinga",
      "trigger_job_now": "Kveikja Verk Núna",
      "trigger_success_message": "Starf \"{jobName}\" framkallað með góðum árangri",
      "trigger_success_title": "Starf Framkallað",
      "triggers": "Kveikir",
      "tuesday": "Þriðjudagur",
      "type": "Tegund",
      "value": "Gildi",
      "wednesday": "Miðvikudagur",
      "yes": "Já"
    }
  }
}
